import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HotToastService } from '@ngneat/hot-toast';
import { Observable, Subscription, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from 'src/app/modules/auth';
import { AuthModel } from 'src/app/modules/auth/_models/auth.model';
import { TranslationService } from 'src/app/modules/i18n/translation.service';
import { HospitalService } from '../_services';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';


@Component({
  selector: 'app-medicine-log',
  templateUrl: './medicine-log.component.html',
  styleUrls: ['./medicine-log.component.scss']
})
export class MedicineLogComponent implements OnInit {

  isLoading$: Observable<boolean>;
  private subscriptions: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
  language: any;
  VisitId: any;
  medicines: any[] = []

  constructor(private fb: FormBuilder, private HospitalService: HospitalService, private route: ActivatedRoute, private router: Router,
    private translationService: TranslationService, private auth: AuthService, private toast: HotToastService) {
  }
  ngOnInit(): void {
    this.VisitId = this.route.snapshot.params['visitId'];
    this.LoadMedicines();
    this.language = this.translationService.getSelectedLanguage();
    this.isLoading$ = this.HospitalService.isLoading$;
  }
  LoadMedicines() {
    const sb = this.HospitalService.GetPrescription(this.VisitId).subscribe(res => {
      if (res.data != null && res.isSuccess) {
        this.medicines = res.data;
      }
    });
    this.subscriptions.push(sb);

  }

  MedicineTaked(medicine) {
    this.HospitalService.showLoader();
    let MedicineLog = {
      VisitId: medicine.visit_ID,
      InsertionDate: new Date(),
      MedicineId: medicine.itemid
    }
    const Subscr = this.HospitalService.AddMedicineLog(MedicineLog).pipe(
      catchError((errorMessage) => {
        this.HospitalService.hideLoader();
        return of(errorMessage);
      })
    ).subscribe(res => {
      if (res.isSuccess && res.responseCode == 200) {
        this.toast.success("<b>" + res.message + "</b>", { style: { padding: '20px' } });
        this.HospitalService.hideLoader();
        setTimeout(() => {
          this.router.navigate(['/'])
        }, 1000);

      }
      else if (!res.error?.isSuccess && res.error?.responseCode == 404) {
        this.toast.warning("<b>" + res.error?.message + "</b>", { style: { padding: '20px' } });
        this.HospitalService.hideLoader();
      }
      else if (!res.error?.isSuccess && res.error?.responseCode == 500) {
        if (this.language == "ar") {
          this.toast.warning("<b>حدث خطأ ما ، من فضلك ، حاول مرة أخرى لاحقًا</b>", { style: { padding: '20px' } });
        }
        else {
          this.toast.warning("<b>Something went wrong, try again later, please</b>", { style: { padding: '20px' } });
        }
        this.HospitalService.hideLoader();

      }
      else {
        if (this.language == "ar") {
          this.toast.warning("<b>حدث خطأ ما ، من فضلك ، حاول مرة أخرى لاحقًا</b>", { style: { padding: '20px' } });
        }
        else {
          this.toast.warning("<b>Something went wrong, try again later, please</b>", { style: { padding: '20px' } });
        }
        this.HospitalService.hideLoader();

      }
    });
    this.subscriptions.push(Subscr);
  }

}
